import React, { useEffect } from 'react';
import { amplitudeConfig } from '../config';
import { startAnalyticsSender, stopAnalyticsSender } from './analyticsSender';
import * as amplitude from '@amplitude/analytics-browser';

const sleep = async (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

type WebAnalyticsContextProps = {};

const WebAnalyticsContext = React.createContext<WebAnalyticsContextProps>({
  instance: undefined,
});

export const WebAnalyticsProvider = (props: React.PropsWithChildren<{}>) => {
  useEffect(() => {
    startAnalyticsSender();
    return () => {
      stopAnalyticsSender();
    };
  }, []);

  useEffect(() => {
    if (amplitudeConfig.enabled) {
      logger.info('Loading analytics');
      const loadAnalyticsImpl = async () => {
        await amplitude.init(amplitudeConfig.api, {
          autocapture: {
            formInteractions: false,
            pageViews: false,
          },
        }).promise;
        logger.info('Analytics loaded');
      };

      const loadAnalytics = async () => {
        await loadAnalyticsImpl().catch(async (err) => {
          logger.error('Error while loading analytics, will try again: ', err);
          await sleep(1000);
          await loadAnalyticsImpl().catch((err) =>
            logger.error('Error while loading analytics for the second time: ', err)
          );
        });
      };
      loadAnalytics();
    } else {
      logger.info('Analytics disabled, skipping initialization.');
    }
  }, []);

  logger.info('Analytics initialized');
  return <WebAnalyticsContext.Provider value={{}} {...props} />;
};
